export default {
    description: "Descripción",
    orderingNote: "Nota de pedido"
}